import React from 'react';
import PropTypes from 'prop-types';
import PageContainer from '../../../layout/PageContainer';
import CreditLine from './CreditLine';

const CreditLineContainer = ({
  match: {
    params: { policyId },
  },
  location: { search, state },
}) => {
  const initialClient = state?.client || null;
  
  return (
    <PageContainer
      breadcrumbs={[
        { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
        { id: 1, name: 'DETALLE LÍNEA CARTERA CLIENTES', url: '/asegurado/lineas-credito/' },
        { id: 2, name: 'LÍNEAS DE CRÉDITO' },
      ]}
      clientFilter={{
        type: 'cliente',
        showFilter: false,
      }}
      returnTo={state && state.returnTo ? state.returnTo : ''}
      initialClient={initialClient}
    >
      {(client, handleClienteChange) => {
        return (
          <CreditLine
            policyId={policyId}
            locationSearch={search}
            client={client}
            handleClienteChange={handleClienteChange}
          />
        )
      }}
    </PageContainer>
  );
};

CreditLineContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      policyId: PropTypes.string,
    }),
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    state: PropTypes.shape({
      returnTo: PropTypes.string,
    }),
  }).isRequired,
};

export default CreditLineContainer;
